module.exports = __webpack_public_path__ + "static/media/4ODA7.3311dc68.jpg";